import React from 'react';

function Contact(props) {
    return (
        <svg
            stroke={props.stroke}
            fill={props.fill}
            strokeWidth="0"
            version="1.1"
            id="mdi-headphones"
            viewBox="0 0 24 24"
            class={props.className}
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M12,1C7,1 3,5 3,10V17A3,3 0 0,0 6,20H9V12H5V10A7,7 0 0,1 12,3A7,7 0 0,1 19,10V12H15V20H18A3,3 0 0,0 21,17V10C21,5 16.97,1 12,1Z"></path>
        </svg>
    );
}

export default Contact;
